import { Component, AfterViewInit, EventEmitter, Output, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { BaseComponent } from '@app/core/components/base/base.component';
import { environment } from '@environment';

import { GoogleLoginService } from '@core/services/login/google-login.service';
import { LoginService } from '@core/services/login/login.service';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { CustomerService } from '@core/services/customer/customer.service';
import { UtilityService } from '@core/services/util/utility.service';
import { ToastrService } from '@app/core/services/notification/toastr.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MainMobileNumberComponent } from '../../common/main-mobile-number/main-mobile-number.component';
import { NgClass, NgStyle } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-mobile-number',
    templateUrl: './mobile-number.component.html',
    styleUrls: ['./mobile-number.component.scss'],
    standalone: true,
    imports: [NgClass, MainMobileNumberComponent, MatProgressSpinnerModule, NgStyle]
})
export class MobileNumberComponent extends BaseComponent implements AfterViewInit {
    @Output() closeDialog = new EventEmitter();
    verifyRequestSub: BehaviorSubject<number> = new BehaviorSubject(0);

    DEPLOY_URL: string;
    trucallerLoginInProgress = false;

    isDesktopCartPage = false;
    sdkLoaded = false;
    showLoader = true;

    constructor(
        private loginService: LoginService,
        private googleLoginService: GoogleLoginService,
        private authenticationService: AuthenticationService,
        private customerService: CustomerService,
        private utilityService: UtilityService,
        private ngZone: NgZone,
        private toastrService: ToastrService,
        private router: Router
    ) {
        super();
        this.DEPLOY_URL = environment.DEPLOY_URL;
        this.utilityService.currentHeaderState.subscribe(data => {
            this.isDesktopCartPage = data.isCartPage && !this.isMobile;
        });
    }

    ngAfterViewInit() {
        const signInModalWidth = document.getElementById('sign-in-btn')?.getBoundingClientRect()?.width;
        this.googleLoginService
            .loadGoogleSDK(this.gSuccessCallback.bind(this), signInModalWidth)
            .then(data => {
                if (data) {
                    setTimeout(() => {
                        this.showLoader = false;
                        this.sdkLoaded = true;
                    }, 600);
                } else {
                    this.showLoader = false;
                }
            })
            .catch(err => console.log(err));
    }

    gSuccessCallback(credential) {
        this.loginService
            .ensureSessionId()
            .then(() => {
                return this.loginService.signinWithGoogle(credential).toPromise();
            })
            .then((response: any) => {
                this.ngZone.run(() => {
                    const code = response.meta.code;

                    switch (code) {
                        case 200:
                            this.authenticationService.closeWrapperDialog.next({ authentication: true });
                            this.customerService.setAuthTokenAndFetchDetails(response);
                            break;
                        case 201:
                            this.authenticationService.nextStep('otp-verification');
                            break;
                        case 405:
                            this.authenticationService.nextStep('gmail-mobile-verify');
                            break;
                        default:
                            break;
                    }
                });
            })
            .catch((error: any) => {
                this.toastrService.openSnackBar(error?.meta?.message, 'OKAY');
            });
    }

    gFailureCallback(error) {
        console.log(error);
    }

    navigateToTnc() {
        this.ngZone.run(() => {
            this.authenticationService.closeWrapperDialog.next({ authentication: false });
            setTimeout(() => {
                this.router.navigateByUrl('/privacy_policy');
            }, 100);
        });
    }
}
